import React, { Component } from "react";
import { Button, Modal, Form, Spinner } from "react-bootstrap";

interface ModalProps {
  showModal: boolean;
  title: string;
  label: string;
  actionButton: string;
  onSave: (event: any) => void;
  onClose: (event: any) => void;
  startingValue: string;
  updateValue: (event: any) => void;
  loadingStatus: boolean;
}

// * Modal used for getting text input.

class JobTitleModal extends Component<ModalProps, {}> {
  render() {
    return (
      //!!r-18-jw
      //@ts-ignore
      <Modal show={this.props.showModal} onHide={this.props.onClose} centered>
        <Modal.Header>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={this.props.onSave}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>{this.props.label}</Form.Label>
              <Form.Control
                type="text"
                autoFocus
                defaultValue={this.props.startingValue}
                onChange={this.props.updateValue}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          {!this.props.loadingStatus ? (
            <>
              <Button variant="secondary" onClick={this.props.onClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={this.props.onSave}>
                {this.props.actionButton}
              </Button>
            </>
          ) : (
            <>
              <Button variant="secondary" disabled>
                Cancel
              </Button>
              <Button variant="primary" disabled>
                <Spinner animation="border" role="status" size="sm"></Spinner>
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default JobTitleModal;
